import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AffichageCguComponent } from './affichage-cgu/affichage-cgu.component';

const routes: Routes = [
  { path: '', component: AffichageCguComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AffichageCguRoutingModule { }
